module.exports = __webpack_public_path__ + "assets/img/mask-life-long.7c946134.png";